export {TsImageEditTools} from './ts-image-edit-tools.component';
export {default as TsImageEditToolsController} from './ts-image-edit-tools.controller';
export type {ITsImageEditToolsController} from './ts-image-edit-tools.controller';
